import { Injectable } from '@angular/core';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
import { ConnectedDeviceAppVersions, ConnectedDeviceSetting, ConnectedDeviceSettingInput } from '../../entities/connectedDeviceSetting/connectedDeviceSetting';
import { Observable, of, switchMap, take } from 'rxjs';
/**
 * The users service.
 */
@Injectable()
export class ConnectedDeviceSettingsService {
  constructor(
    private apolloService: ApolloService,
  ) {}


  /**
   * updates connected device setting
   * @param connectedDeviceSettingInput connected device setting input
   * @param callback method
   */
  public updateConnectedDeviceSetting(connectedDeviceSettingInput: ConnectedDeviceSettingInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_CONNECTED_DEVICE_SETTING,
      {
        input: connectedDeviceSettingInput,
      },
      callback
    );
  }

  /**
   * updates connected device settings
   * @param connectedDeviceSettingInputs connected device setting inputs
   * @param callback method 
   */
  public updateConnectedDeviceSettings(connectedDeviceSettingInputs: ConnectedDeviceSettingInput[], callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_CONNECTED_DEVICE_SETTINGS,
      {
        inputs: connectedDeviceSettingInputs,
      },
      callback
    );
  }

  public getConnectedDeviceSetting(key: string): Observable<ConnectedDeviceSetting> {
    return this.apolloService.query<fromGraphQl.GetConnectedDeviceSettingResponse>(
      fromGraphQl.GET_CONNECTED_DEVICE_SETTING,
        {
          key: key
        })
    .pipe(
      take(1),
      switchMap( (result) => {
        return of( new ConnectedDeviceSetting(result.data.getConnectedDeviceSetting));
      })
    );
  }

  public getConnectedDeviceSettings(keys: string[]): Observable<ConnectedDeviceSetting[]> {
    return this.apolloService.query<fromGraphQl.GetConnectedDeviceSettingResponse>(
      fromGraphQl.GET_CONNECTED_DEVICE_SETTINGS,
        {
          keys: keys
        })
    .pipe(
      take(1),
      switchMap( (result) => {
        return of( ConnectedDeviceSetting.createConnectedDeviceSettings(result.data.getConnectedDeviceSettings));
      })
    );
  }

  public getAppVersions(platform: string): Observable<ConnectedDeviceAppVersions> {
    return this.apolloService.query<fromGraphQl.GetAppVersionsResponse>(
      fromGraphQl.GET_APP_VERSIONS,
        {
          platform: platform
        })
    .pipe(
      take(1),
      switchMap( (result) => {
        return of( new ConnectedDeviceAppVersions(result.data.getAppVersions));
      })
    );
  }

}
